import { render, staticRenderFns } from "./statustable.vue?vue&type=template&id=7dd53854&scoped=true"
import script from "./statustable.vue?vue&type=script&lang=js"
export * from "./statustable.vue?vue&type=script&lang=js"
import style0 from "./statustable.vue?vue&type=style&index=0&id=7dd53854&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd53854",
  null
  
)

export default component.exports